import React from 'react';
import { motion } from 'framer-motion';
import { VscBook } from 'react-icons/vsc';
import { image } from 'framer-motion/client';

class Hero extends React.Component {
    render() {
      return (
        <section id="home" className="bg-gray-900 text-white py-20 px-4">
          <div className="max-w-6xl mx-auto text-center">
            <h1 className="text-5xl font-bold mb-6">
              Queime Gordura com Diego Trainer<br />
              <span className="text-blue-500">Teste Grátis de 14 Dias</span> + eBook
            </h1>

            <div className="mb-8 flex items-center justify-center space-x-4">
              <VscBook className="text-blue-500 text-4xl" />
              <span className="text-xl">eBook "Dieta Sustentável para Perda de Gordura" Incluso</span>
            </div>
            <a 
              href="https://training-app.short.gy/train-with-diego-trainer" 
              target="_blank" 
              rel="noopener noreferrer"
            >
              <button className="bg-blue-500 hover:bg-blue-600 text-white font-bold py-3 px-8 rounded-lg text-lg mb-4">
                Adquira o Teste Grátis & eBook →
              </button>
            </a>

            <p className="text-sm text-gray-300">
              14 Dias de Teste Grátis • Após R$149.90/mês • Cancele a Qualquer Momento
            </p>

            {/* Seção de Capturas de Tela do App */}
            <motion.div 
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 1 }}
              viewport={{ once: true }}
              className="mt-12"
            >
              <div className="flex overflow-x-auto pb-4 gap-4 justify-start md:justify-center">
                <motion.div 
                  whileHover={{ scale: 1.05 }}
                  className="flex-shrink-0 w-48 relative rounded-lg shadow-xl"
                  initial={{ x: -50 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: image.delay, duration: 0.8 }}
                  viewport={{ once: true }}
                >
                  <img 
                    src="/assets/screens/workout-plan.png" 
                    alt="Plano de Treino" 
                    className="w-full h-auto object-contain rounded-lg border-2 border-gray-800"
                  />
                </motion.div>
  
                <motion.div 
                  whileHover={{ scale: 1.05 }}
                  className="flex-shrink-0 w-48 relative rounded-lg shadow-xl"
                  initial={{ x: -50 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: image.delay, duration: 0.8 }}
                  viewport={{ once: true }}
                >
                  <img 
                    src="/assets/screens/workout-tracker.png" 
                    alt="Monitoramente de Treino" 
                    className="w-full h-auto object-contain rounded-lg border-2 border-gray-800"
                  />
                </motion.div>
  
                <motion.div 
                  whileHover={{ scale: 1.05 }}
                  className="flex-shrink-0 w-48 relative rounded-lg shadow-xl"
                  initial={{ x: -50 }}
                  animate={{ x: 0, opacity: 1 }}
                  transition={{ delay: image.delay, duration: 0.8 }}
                  viewport={{ once: true }}
                >
                  <img 
                    src="/assets/screens/body-tracker.png" 
                    alt="Acompanhamento de Progresso" 
                    className="w-full h-auto object-contain rounded-lg border-2 border-gray-800"
                  />
                </motion.div>
              </div>
  
              <p className="mt-6 text-gray-400 text-sm px-4">
                Deslize para ver os recursos do app • Exemplos reais da interface do cliente
              </p>
            </motion.div>
          </div>
        </section>
      );
    }
  }

  export default Hero;
